// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Madagascar from '../_raw/flag/icon_flag_madagascar.png';

export default () => <img src={Madagascar} alt="Madagascar" />;
